import { ServiceContractType } from 'api/types/entity';
import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';
import { DocumentsTableFeature } from 'modules/client/common/feature';
import { Field } from 'modules/client/common/forms/serviceContractForm';

interface ServiceContractSectionProps {
  enabledDocuments?: boolean;
}

export const ServiceContractSection = ({
  enabledDocuments = false,
}: ServiceContractSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="serviceContractSection"
      title={t('client.serviceContractSection.title')}
    >
      <GridFields>
        <Field.Autocomplete
          label={t('client.serviceContractSection.type.label')}
          name="serviceContract.type"
          optionLabelKey="label"
          options={Object.values(ServiceContractType).map((v) => ({
            label: t(`client.serviceContractSection.type.types.${v}`),
            value: v,
          }))}
          optionValueKey="value"
          placeholder={t('client.serviceContractSection.type.placeholder')}
          variant="select"
        />

        <Field.Text
          label={t('client.serviceContractSection.number.label')}
          name="serviceContract.number"
          placeholder={t('client.serviceContractSection.number.placeholder')}
        />

        <Field.DatePicker
          disableFuture={false}
          label={t('client.serviceContractSection.conclusionDate.label')}
          name="serviceContract.conclusionDate"
          placeholder={t(
            'client.serviceContractSection.conclusionDate.placeholder'
          )}
        />
        <Field.DatePicker
          disableFuture={false}
          label={t('client.serviceContractSection.terminationDate.label')}
          name="serviceContract.terminationDate"
          placeholder={t(
            'client.serviceContractSection.terminationDate.placeholder'
          )}
        />
      </GridFields>
      {enabledDocuments && (
        <DocumentsTableFeature
          maxDocumentCount={1}
          name="serviceContract.document_Finance"
        />
      )}
    </Section>
  );
};
